(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/utils/url-helper.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/utils/url-helper.js'); "use strict";

(function (svs) {
  'use strict';

  function getReturnUrl() {
    var returnUrl;
    var logger = svs.core.log.getLogger('modules:player-login'),
        userAgentFamily = svs.player_login.data.login.useragent_family,
        isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;

    if (svs.core.detect.browser.crios()) {
      if (window.location.protocol.indexOf('s') > -1) {
        returnUrl = 'googlechromes://';
      } else {
        returnUrl = 'googlechrome://';
      }
    } else {
      if (svs.core.detect.os.iOS()) {
        if (isNativeApp) {
          returnUrl = encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid'));
        } else if (userAgentFamily.indexOf('firefox') > -1) {
          returnUrl = encodeURIComponent("firefox://open-url?url=".concat(svs.utils.url.currentUrlEncodedParams()));
        } else if (userAgentFamily.indexOf('safari') > -1) {
          returnUrl = encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
        } else {
          returnUrl = 'null'; 
        }
      } else {
        returnUrl = 'null';
      }
    }

    logger.debug("Bankid/Freja eID return url: ".concat(returnUrl));
    return returnUrl;
  }

  svs.player_login.utils.url = {
    getBankIDAppUrl: function getBankIDAppUrl(autoStartToken) {
      var url;
      var logger = svs.core.log.getLogger('modules:player-login');

      if (svs.core.detect.os.android()) {
        url = "intent:///?autostarttoken=".concat(autoStartToken, "&redirect=null#Intent;scheme=bankid;package=com.bankid.bus;S.browser_fallback_url=").concat(encodeURIComponent("".concat(window.location.origin, "/inget-bankid")), ";end");
      } else if (svs.core.detect.formfactor.desktop()) {
        url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=null");
      } else {
        url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getReturnUrl(autoStartToken));
      }

      logger.debug("Bankid start url: ".concat(url));
      return url;
    },
    getFrejaEidAppUrl: function getFrejaEidAppUrl(authRef) {
      var url;
      var logger = svs.core.log.getLogger('modules:player-login'),
          urlEncodedAuthRef = encodeURIComponent(authRef);

      if (svs.core.detect.os.android()) {
        url = "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef);
      } else if (svs.core.detect.formfactor.desktop()) {
        url = "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef);
      } else {
        url = "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef, "&originAppScheme=").concat(getReturnUrl(urlEncodedAuthRef));
      }

      logger.debug("Freja eID start url: ".concat(url));
      logger.info("Freja eID start url: ".concat(url));
      return url;
    }
  };
})(svs, jQuery);
 })(window);